import { connect } from 'react-redux'
import { compose } from 'redux'
import { push } from 'connected-react-router'
import toJS from '../../../hoc/toJS'
import PageSocialMediaPreset from '../present/PageSocialMediaPreset'
import actionTypes from '../../../actions/actionTypes'
import { SOCIAL_MEDIA_DATA, THEME } from '../../../constants/state'
import getData from '../../../functions/getData'
import config from '../../../config.json'

const mapStateToProps = (state, ownProps) => {
    const presetId = ownProps.match.params.presetId
    const presets  = state.getIn([SOCIAL_MEDIA_DATA, 'presets'])
    const preset   = presets ? presets.find(p => p.get('id') === presetId) : null
    return {
        preset:           preset ? preset : null,
        presets:          presets,
        presetId,
        cinemaId:         ownProps.match.params.cinemaId,
        isLoading:        state.getIn([SOCIAL_MEDIA_DATA, 'isLoading']),
        themeData:        getData(state, THEME),
        translationStrings: state.getIn(['translation', 'strings']),
        currentLang:      state.getIn(['translation', 'currentLang']),
        translationDebug: state.getIn(['translation', 'debug']),
    }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
    onSave: (presetData, presetId) => {
        const type = presetId
            ? actionTypes.SOCIAL_MEDIA_PRESET_UPDATE_REQUEST
            : actionTypes.SOCIAL_MEDIA_PRESET_CREATE_REQUEST
        dispatch({ type, payload: presetData })
    },
    onBack: () => {
        const cinemaId = ownProps.match.params.cinemaId
        dispatch(push(`${config.routes.socialMedia.path}/${cinemaId}`))
    },
})

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(PageSocialMediaPreset)
